var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-divider',{attrs:{"orientation":"left"}},[_vm._v(_vm._s(_vm.user.dep)+" 必修")]),_c('course-list-simplified',{attrs:{"present-courses":_vm.presentCourses,"courses-source":_vm.allCoursesList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }